import { MuiAlert } from '@fox/atoms';
import { useState } from 'react';
import { CompactItemsWrapper, ResponsiveItemWrapper } from '../../NewsList/shared';
import { SwiftFoxEvent } from '../events/contracts';
import { CompactEventItem } from './compact-view-item';
import { DesktopEventDrawer } from './details-drawer';
import { useEventListContext } from './event-list-context';

export function CompactView() {
	const { events } = useEventListContext();
	return (
		<ResponsiveItemWrapper>
			<CompactItemsWrapper>
				{events?.map(event => (
					<CompactItem event={event} />
				))}
				{events?.length === 0 ? <MuiAlert severity="info">No events to display</MuiAlert> : null}
			</CompactItemsWrapper>
		</ResponsiveItemWrapper>
	);
}

function CompactItem({ event }: { event: SwiftFoxEvent }) {
	const [deskTopDrawerOpen, setDesktopDrawerOpen] = useState<boolean>(false);
	return (
		<div style={{ width: '100%' }} key={event.id}>
			<div style={{ cursor: 'pointer' }} onClick={() => setDesktopDrawerOpen(true)}>
				<CompactEventItem event={event} />
			</div>
			<DesktopEventDrawer drawerOpen={deskTopDrawerOpen} setDrawerOpen={setDesktopDrawerOpen} eventId={event.id} />
		</div>
	);
}
